var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreventRecording(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.329,
    height: 28.819,
    viewBox: "0 0 25.329 28.819",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Voice_recording",
    transform: "translate(-284.653 -308.417)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 9.523,
    height: 14.814,
    transform: "translate(292.861 312.65)",
    fill: "#4c66d6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "microphone_1_",
    "data-name": "microphone (1)",
    transform: "translate(284.653 308.417)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M108.73,271a.844.844,0,0,0-.844.844,7.6,7.6,0,1,1-15.2,0,.844.844,0,0,0-1.689,0,9.351,9.351,0,0,0,8.443,9.3v1.731H96.91a.844.844,0,1,0,0,1.689h6.754a.844.844,0,1,0,0-1.689h-2.533v-1.731a9.351,9.351,0,0,0,8.443-9.3A.844.844,0,0,0,108.73,271Z",
    transform: "translate(-87.623 -255.746)",
    fill: "#a3cfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M151,16.1a5.91,5.91,0,1,0,11.82,0V5.966a5.91,5.91,0,1,0-11.82,0Zm4.222-9.287H158.6a.844.844,0,1,1,0,1.689h-3.377a.844.844,0,0,1,0-1.689Zm0,3.377H158.6a.844.844,0,1,1,0,1.689h-3.377a.844.844,0,0,1,0-1.689Zm0,3.377H158.6a.844.844,0,1,1,0,1.689h-3.377a.844.844,0,0,1,0-1.689Z",
    transform: "translate(-144.246 0)",
    fill: "#a3cfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M391.844,121a.844.844,0,0,0-.844.844v3.377a.844.844,0,1,0,1.689,0v-3.377A.844.844,0,0,0,391.844,121Z",
    transform: "translate(-370.737 -114.189)",
    fill: "#4c66d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M451.844,91a.844.844,0,0,0-.844.844V98.6a.844.844,0,1,0,1.689,0V91.844A.844.844,0,0,0,451.844,91Z",
    transform: "translate(-427.359 -85.878)",
    fill: "#4c66d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M91,121.844v3.377a.844.844,0,0,0,1.689,0v-3.377a.844.844,0,1,0-1.689,0Z",
    transform: "translate(-87.623 -114.189)",
    fill: "#4c66d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M31.844,91a.844.844,0,0,0-.844.844V98.6a.844.844,0,0,0,1.689,0V91.844A.844.844,0,0,0,31.844,91Z",
    transform: "translate(-31 -85.878)",
    fill: "#4c66d6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreventRecording);
export default __webpack_public_path__ + "static/media/PreventRecording.43520aa5db0b054d4deacf5b1a55e540.svg";
export { ForwardRef as ReactComponent };